export function findingBriefElementId(findingId: string): string {
  return `finding-brief-${findingId}`;
}

export function scrollToEmployerReviewTarget(
  targetId: string,
  behavior: ScrollBehavior = 'smooth',
): void {
  requestAnimationFrame(() => {
    document.getElementById(targetId)?.scrollIntoView({ behavior, block: 'start' });
  });
}
